define('ctrl/base',['require','ns','core/utils'],function (require) {
	'use strict';

	var ns = require('ns');
	
	var utils = require('core/utils');
	
	var BaseController = function () {

		this.init.apply(this, arguments);
	};

	BaseController.extend = utils.extend;

	BaseController.prototype = {

		init: function () {
			
			ns.logger.debug('BaseController', 'initialized');
		}
	};

	return BaseController;
});
